

































































import { computed, defineComponent, onMounted, ref } from "@vue/composition-api";
import { format, getNow, isValid, parse } from "@/lib/time";
import { InputMaskOptions } from "@/modules/inputMask";
import { INPUT_PROPS } from "@/const";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseInputBox from "@/components/BaseInputBox";

export default defineComponent({
  name: "DateTimeField",
  components: { BaseIcon, BaseInputBox },
  props: {
    ...INPUT_PROPS,
    min: { type: [Date, String] },
    max: { type: [Date, String] },
    dateFormat: { type: String, default: "MM/dd/yyyy" },
    timeFormat: { type: String, default: "hh:mm a" },
    errors: { type: Array, default: () => [] },
  },
  setup(props, { emit }) {
    const inputDateElement = ref<HTMLInputElement>();
    const inputTimeElement = ref<HTMLInputElement>();
    const supportDate = ref(true);
    const supportTime = ref(true);

    const timeValue = ref("");
    const dateValue = ref("");

    const currentDate = computed(() => props.value.split(" ")[0]);

    const currentTime = computed(() => props.value.split(" ")[1]);

    const datePlaceholder = computed(() => props.dateFormat.toUpperCase());
    const timePlaceholder = computed(() => props.timeFormat.toUpperCase().replace("TT", "AM"));

    const minDateValue = computed(() => {
      const date = props.min ? new Date(props.min) : getNow();
      if (!supportDate.value) return format(date, props.dateFormat);
      return format(date, "yyyy-MM-dd");
    });
    const maxDateValue = computed(() => {
      const date = props.max ? new Date(props.max) : new Date(getNow().setFullYear(getNow().getFullYear() + 1));
      if (!supportDate.value) return format(date, props.dateFormat);
      return format(date, "yyyy-MM-dd");
    });

    const dateOpts = computed<InputMaskOptions>(() => ({
      alias: "datetime",
      inputmode: "numeric",
      inputFormat: props.dateFormat,
      placeholder: datePlaceholder.value,
      min: minDateValue.value,
      max: maxDateValue.value,
    }));

    const timeOpts = computed<InputMaskOptions>(() => ({
      showMaskOnHover: false,
      showMaskOnFocus: false,
      alias: "datetime",
      inputFormat: props.timeFormat,
      placeholder: timePlaceholder.value,
    }));

    const onInput = () => {
      const value = dateValue.value + " " + timeValue.value;
      const date = parse(value, props.dateFormat, getNow());
      if (isValid(date)) {
        emit("input", format(date, "yyyy-MM-dd hh:mm:ss"));
      } else emit("input", value);
    };

    const onInputDate = (e: InputEvent) => {
      dateValue.value = (e.target as HTMLInputElement).value;
      onInput();
    };

    const onInputTime = (e: InputEvent) => {
      timeValue.value = (e.target as HTMLInputElement).value;
      onInput();
    };

    onMounted(() => {
      supportDate.value = inputDateElement.value?.type === "date";
      supportTime.value = inputTimeElement.value?.type === "time";
    });

    return {
      inputDateElement,
      inputTimeElement,
      supportDate,
      supportTime,
      datePlaceholder,
      timePlaceholder,
      minDateValue,
      maxDateValue,
      currentDate,
      currentTime,
      dateOpts,
      timeOpts,
      onInputDate,
      onInputTime,
    };
  },
});
